"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBookingToUTC = transformBookingToUTC;
const getTimezoneOffsetOrDefault_1 = require("../helpers/getTimezoneOffsetOrDefault");
function transformBookingToUTC(date, originLocationTimezone) {
    const offset = (0, getTimezoneOffsetOrDefault_1.getTimezoneOffsetOrDefault)(originLocationTimezone, date);
    // correcting any locale offset of server/client, since it looks like it's in utc, but departure is actually in origin timezone
    const trueUtc = new Date(date.getTime() - offset);
    return trueUtc;
}
//# sourceMappingURL=transformBookingToUTC.js.map